import { render, staticRenderFns } from "./Lengths.vue?vue&type=template&id=13a54656&scoped=true"
import script from "./Lengths.vue?vue&type=script&lang=js"
export * from "./Lengths.vue?vue&type=script&lang=js"
import style0 from "./Lengths.vue?vue&type=style&index=0&id=13a54656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a54656",
  null
  
)

export default component.exports